import React, { Component } from 'react';
import {Form, Control, /*Fieldset, */Errors} from 'react-redux-form';
import _ from 'lodash';
import {isCurp, isEmail, isRequired, isRfc, maxLength, minValue, required/*, required*/} from "../field_validations";
import DatePick from "../forms/datepicker";
import {allLower, allUpper/*, firstCapital*/} from "../parsers";
import BigFileUpload from "../widgets/big_file_upload";
import {formatMoney} from "accounting-js";
import Loading from "../loading";
import {confirmAlert} from "react-confirm-alert";

export default class Employees extends Component{
	render(){
		const {reports, match} = this.props;
		const {modality} = match.params;
		const {employees} = reports;
		const {revision} = employees;
		let ec = _.find(reports.permissions, (o) => {return o==='Create'}) ? true:false;
		return(
			<div className="columns is-centered">
				{this.state.modalPeopleAddShow ? <ModalPeopleAdd active={this.state.modalPeopleAddShow} peopleIndex={this.state.peopleIndex} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
				<div className="column">
					{/*match.params.modality !== 'modalidad-iii'*/ true ? // Se deshabilito la validación hasta que se cree la versión 2019 de eTrans
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							{ec ?
							<button className="button is-success" onClick={() => this._addPeople()} disabled={employees.data.editable ? false:true}>
								<i className="fa fa-plus-circle"/>&nbsp;Agregar persona
							</button>
							:''}
						</div>
					</div>:''}

					<table className="inm-table">
						<thead>
						<tr>
							<th>No.</th>
							<th>Nombre</th>
							<th>Formación académica</th>
							{match.params.modality !== 'modalidad-iii' ?
							<th>Funciones</th>
							:<th>Perfil</th>}
							<th>RFC</th>
							<th>Instancia</th>
						</tr>
						</thead>
						<tbody>
						{!_.isEmpty(employees.data) && !_.isEmpty(employees.data.employees) ?
							_.map(employees.data.employees,(row,k) => {
								//let projectGoalAgency = !_.isEmpty(row.project_goal_agency) ? row.project_goal_agency:undefined;
								let revisionFinancial = !_.isEmpty(revision) && !_.isEmpty(revision.body) ? revision.body:undefined;
								let findGoal = _.find(employees.data.project_goals, {id: row.project_goal_id});

								let goalRevision = undefined;
								let goalRevisionAllowEdit = undefined;

								if(modality!=='modalidad-iii'){
									goalRevision = revisionFinancial && !_.isEmpty(revisionFinancial.goals) && !_.isEmpty(revisionFinancial.goals[findGoal.id]) ? revisionFinancial.goals[findGoal.id]: undefined
									goalRevisionAllowEdit = goalRevision && !_.isEmpty(goalRevision.allow_edit) ? (goalRevision.allow_edit === 'true' ? true:false):undefined;
								}else {
									goalRevision = findGoal && revisionFinancial && !_.isEmpty(revisionFinancial.goals) && !_.isEmpty(revisionFinancial.goals[findGoal.id]) && !_.isEmpty(revisionFinancial.goals[findGoal.id].agencies[row.agency_id]) ? revisionFinancial.goals[findGoal.id].agencies[row.agency_id]: undefined;
									goalRevisionAllowEdit = goalRevision && !_.isEmpty(goalRevision.allow_edit) ? (goalRevision.allow_edit === 'true' ? true:false):undefined;
								}

								let validEditGoal = ec ? (revisionFinancial && goalRevisionAllowEdit !== undefined  ? goalRevisionAllowEdit:(revisionFinancial && goalRevisionAllowEdit === undefined ? false:ec)):false;

								return[
									<tr key={k}>
										<td style={{width: 10 + '%'}} rowSpan={revisionFinancial && goalRevision && goalRevision.comment ? 3:2}>
											{this.state.modalMessageExpensesShow && k === this.state.employeesIndex ?
												<ModalMessageExpenses active={this.state.modalMessageExpensesShow} data={row} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
											<div className="actions">
												<button style={{cursor: 'pointer'}} onClick={() => this._showMessageExpenses(k)}><i className="fa fa-eye"></i></button>
												{validEditGoal ? <button type="button" style={{cursor: 'pointer'}} onClick={() => this._editPeopleHired(k)} ><i className="fa fa-edit"></i></button> :''}
											</div>
											{k + 1}
										</td>
										<td><strong>{`${row.name} ${row.last_name} ${row.slast_name ? row.slast_name:''}`}</strong></td>
										<td>{row.scholarship}</td>
										{match.params.modality !== 'modalidad-iii' ?
										<td>{row.job_function}</td>
										:<td>{row.role.display}</td>}
										<td>{row.rfc}</td>
										<td>{row.agency && row.agency.agenciable ? row.agency.agenciable.name:'---' }</td>
									</tr>,
									<tr key={`meta-${k}`}>
										<td colSpan={5}>
											<p className="has-text-inm-purple"><strong>META</strong></p>
											{findGoal ? <small><b>{`(${findGoal.code})`}</b>{findGoal.name}</small>:<small>---</small>}
										</td>
									</tr>,
									goalRevision && goalRevision.comment ?
									<tr key={`rev-${k}`}>
										<td colSpan={5}>
											<div className={`notification ${goalRevision.status ? `is-${goalRevision.status}`:''}`}>
												<i className="fa fa-info"/>&nbsp;
												{goalRevision.comment}
											</div>
										</td>
									</tr>
									:null
								]
							})
							:<tr>
								<td colSpan={6} className="has-text-centered"><strong>Sin personas contratadas</strong></td>
							</tr>}
						</tbody>
					</table>
				</div>
			</div>
		)
	}

	constructor(){
		super();
		this.state = {
			modalPeopleAddShow:false,
			employeesIndex: undefined,
			modalMessageExpensesShow: false
		}
	}

	_addPeople(){
		this.props.reset('reports.employees.edit');

		this.setState({
			modalPeopleAddShow: true
		})
	}

	_editPeopleHired(indexEmployees) {
		let { employees } = this.props.reports;

		this.props.reset('reports.employees.edit');

		this.props.change('reports.employees.edit',{
			...employees.data.employees[indexEmployees],
			indexEmployees: indexEmployees,
			project_goal_id: employees.data.employees[indexEmployees].project_goal_id,
			agency_id: employees.data.employees[indexEmployees].agency_id
		})

		this.setState({
			modalPeopleAddShow: true,
			employeesIndex: indexEmployees
		})
	}

	_showMessageExpenses(indexEmployees){
		this.setState({
			modalMessageExpensesShow: true,
			employeesIndex: indexEmployees
		})
	}

	_toggleModal() {
		this.setState({
			modalPeopleAddShow: false,
			modalMessageExpensesShow: false
		});
		this.props.reset('reports.employees.edit');
	}
}

class ModalPeopleAdd extends Component{

	render(){
		let { reports, match, session, configs } = this.props;
		let { employees } = reports;
		let rfcPerson = false;
		if (!configs.isFetching) {
			_.map(configs.list, (row, k) => {
				rfcPerson = row && row.name && row.value && row.name === "rfc-person" && row.value === "1";
			})
		}

		return(
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card" >
					<header className="modal-card-head">
						<p className="modal-card-title">Persona contratada</p>
						<button type="button" onClick={this.props.closeModal} className="delete" aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{employees.edit.isFetching ? <Loading/>:
						<Form model="reports.employees.edit" onSubmit={(values) => this._submitForm(values)}>
							<fieldset className="fieldset">
								<legend>DATOS PERSONALES</legend>
								<div className="field">
									<div className="control">
										<label htmlFor="name" className="label">Nombre(s) <span className="small has-text-danger">*</span></label>
										<Control.text model=".name" className="input" id="name" errors={{isRequired}} placeholder="Nombre(s)" validateOn="change" readOnly={employees.edit.id ? true:false}/>
										<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="last_name" className="label">Primer apellido <span className="small has-text-danger">*</span></label>
										<Control.text model=".last_name" className="input" id="last_name" errors={{isRequired}} validateOn="change" readOnly={employees.edit.id ? true:false}/>
										<Errors model=".last_name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El apellido es obligatorio'}} />
									</div>

									<div className="control is-expanded">
										<label htmlFor="slast_name" className="label">Segundo apellido</label>
										<Control.text model=".slast_name" className="input" id="slast_name" readOnly={employees.edit.id ? true:false}/>
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="scholarship" className="label">Formación académica <span className="small has-text-danger">*</span></label>
										<Control.text model=".scholarship" id="scholarship" className="input" placeholder="Formación académica" errors={{isRequired}} validateOn="change" readOnly={employees.edit.id ? true:false}/>
										<Errors model=".scholarship" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatorio'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="email" className="label">Email <span className="small has-text-danger">*</span></label>
										<Control.text model=".email" className="input" placeholder="Email" errors={{isRequired, isEmail}} validateOn="change" parser={ allLower } readOnly={employees.edit.id ? true:false}/>
										<Errors model=".email" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El email es obligatorio'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="curp" className="label">CURP <span className="small has-text-danger">*</span></label>
										<Control.text model=".curp" id="curp" className="input" placeholder="XXXX000000XXXXXX00" errors={{isRequired, maxLength: maxLength(18), isCurp}} validateOn="change" parser={ allUpper } readOnly={employees.edit.id ? true:false}/>
										<Errors model=".curp" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'La CURP es obligatoria. ', isCurp: 'CURP inválida. '}} />
									</div>

									<div className="control is-expanded">
										<label htmlFor="rfc" className="label">RFC <span className="small has-text-danger">*</span></label>
										<Control.text model=".rfc" id="rfc" className="input" placeholder="XXXX000000XX0" errors={{isRequired, isRfc}} validateOn="change" parser={ allUpper } readOnly={employees.edit.id ? true:false}/>
										<Errors model=".rfc" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El RFC es obligatorio. ', isRfc: 'RFC inválido. '}} />
									</div>
								</div>
							</fieldset>

							<fieldset className="fieldset">
								<legend>DATOS DE CONTRATACIÓN</legend>

								<div className="field is-grouped">
									{// Se realiza esta validación porque en 2018 no existía módulo de CDMs (que es donde se registra este dato por medio del perfil del usuario)
									 match.params.modality !== 'modalidad-iii' || session.user.version.year===2018 ?
										<div className="control is-expanded">
											<label htmlFor="job_function" className="label">Función <span className="small has-text-danger">*</span></label>
											<Control.text model=".job_function" id="job_function" className="input" placeholder="Función" errors={{isRequired}} validateOn="change" readOnly={employees.edit.id ? true:false}/>
											<Errors model=".job_function" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatorio'}} />
										</div> : ''
									}
								</div>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="wage" className="label">Ingreso mensual</label>
										<div className="control has-icons-left is-expanded">
											<Control.text model=".wage" id="wage" type="number" step=".01" min="0" className="input" placeholder="0,000.00" errors={{isRequired, minValue: minValue(0)}} validateOn="change" readOnly={employees.edit.id ? true:false}/>
											<span className="icon is-small is-left">
												<i className="fa fa-usd"/>
											</span>
										</div>
										<Errors model=".wage" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
									</div>
								</div>

								<label className="label">Periodo de contratación</label>
								<hr style={{margin:'0px'}}/>
								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="period_start" className="label">Inicia <span className="small has-text-danger">*</span></label>
										<Control model=".period_start" name="period_start" component={DatePick} className="input" errors={{isRequired}} validateOn="change" disabled={employees.edit.id ? true:false}/>
										<Errors model=".period_start" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La fecha es obligatorio'}}/>
									</div>

									<div className="control is-expanded">
										<label htmlFor="period_end" className="label">Termina <span className="small has-text-danger">*</span></label>
										<Control model=".period_end" name="period_end" component={DatePick} className="input" errors={{isRequired}} validateOn="change" disabled={employees.edit.id ? true:false}/>
										<Errors model=".period_end" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La fecha es obligatorio'}}/>
									</div>
								</div>

								{rfcPerson ? <div className="notification is-warning">
									<i className="fa fa-info"/>&nbsp; Si las facturas son expedidas con otro RFC que no es el de la persona contratada, agregalo aquí. <strong>Recuerda que no podrás cambiarlo una vez que lo guardes.</strong>
								</div>:""}
								{rfcPerson ? <div className="field">
									<div className="control">
										<label htmlFor="rfc_invoices" className="label">RFC facturas expedidas </label>
										<Control.text model=".rfc_invoices" id="rfc_invoices" className="input" placeholder="XXXX000000XX0" errors={{ isRfc}} validateOn="change" parser={ allUpper } readOnly={employees.edit.id ? true:false}/>
										<Errors model=".rfc_invoices" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRfc: 'RFC inválido. '}} />
									</div>
								</div>:""}

							</fieldset>

							<fieldset className="fieldset">
								<legend>META RELACIONADA</legend>
								<div className="field">
									<div className="control">
										<div className="select">
											<Control.select model=".project_goal_id" id="project_goal_id" errors={{required}} validateOn="change" disabled={employees.edit.id ? true:false}>
												<option value="">-- Meta --</option>
												{_.map(employees.data.project_goals,(opt, k) => {
													return(
														<option value={opt.id} key={k}>{`${opt.code} - ${_.truncate(opt.name,{'length': 60})}`}</option>
													)
												})}
											</Control.select>
										</div>
										<Errors model=".project_goal_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La meta es obligatoria'}}/>
									</div>
								</div>
							</fieldset>
							{match.params.modality==='modalidad-iii' ?
								employees.edit.project_goal_id ?
								<fieldset className="fieldset">
									<legend>CDM RELACIONADO</legend>
									<div className="field">
										<div className="control">
											<div className="select">
												<Control.select model=".agency_id" id="agency_id" errors={{required}} validateOn="change" disabled={employees.edit.id ? true:false}>
													<option value="">-- CDM --</option>
													{_.map(employees.data.agencies,(opt, k) => {
														return(
															<option value={opt.id} key={k}>{opt.agenciable.name}</option>
														)
													})}
												</Control.select>
											</div>
											<Errors model=".agency_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La meta es obligatoria'}}/>
										</div>
									</div>
								</fieldset>
								:''
							:''}

							<fieldset className="fieldset">
								<legend>AGREGAR CFDI</legend>

								{employees.edit.id ?
									<div className="field is-grouped">
										<BigFileUpload
											model=".pdf"
											name="PDF"
											file={employees.edit.pdf}
											size="small"
											validators={{required}}
											message={{required: 'Falta anexar PDF'}}
										/>

										<BigFileUpload
											model=".xml"
											name="XML"
											file={employees.edit.xml}
											size="small"
											validators={{required}}
											message={{required: 'Falta anexar XML'}}
										/>

										<BigFileUpload
											model=".sat"
											name="Validación SAT"
											file={employees.edit.sat}
											size="small"
											validators={{required}}
											message={{required: 'Falta anexar Validación'}}
										/>
									</div>
									:<div className="notification is-warning">
										<i className="fa fa-exclamation-triangle"/>&nbsp; Para poder agregar facturas, es necesario que primero se registren los datos de la persona contratada, revisa cuidadosamente que sean correctos. Recuerda que el RFC  debe corresponder con el de la factura  que se adjunta.
									</div>}
							</fieldset>

							{!_.isEmpty(employees.edit.invoices) ?
								<fieldset className="fieldset">
									<legend>Facturas</legend>
									<table className="inm-table">
										<thead>
										<tr>
											<th>Factura</th>
											<th>PDF</th>
											<th>XML</th>
											<th>SAT</th>
											<th>Accion</th>
										</tr>
										</thead>
										<tbody>
										{_.map(employees.edit.invoices, (item,k) => {
											return(
												<tr key={k}>
													<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

													<td>
														<div className="control">
															<a href={item.pdf}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.xml}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.sat}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<div className="button is-danger" onClick={() => this._getConfirm(k)} disabled={employees.data.editable ? false:true}>
																<span className="icon"><i className="fa fa-trash-o"/></span>
															</div>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</fieldset>
								:''}

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button is-danger" onClick={this.props.closeModal}>
										Cerrar
									</button>
								</div>
								<div className="control">
									<Control.button model="reports.expenses.edit" className="button is-success"
									                disabled={employees.data.editable ? false:true}>
										Guardar
									</Control.button>
								</div>
							</div>
						</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		)
	}

	componentWillReceiveProps(newprops){
		let {edit} = newprops.reports.employees;
		if(edit !== this.props.reports.employees.edit){
			if(edit.action){
				if(edit.action === 'close'){
					this.props.closeModal();
					this.props.change('reports.employees.edit.action', undefined);
				}else if(edit.action === 'delete' && _.isEmpty(edit.invoices)){
					this.props.closeModal();
					this.props.change('reports.employees.edit.action', undefined);
				}
			}
		}
	}

	_getConfirm(index){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la factura?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this._removeInvoice(index)
		})
	}

	_removeInvoice(index){
		let {employees} = this.props.reports;
		let { modality, state, municipality } = this.props.match.params;

		if(!_.isObject(employees.edit.invoices[index])){
			this.props.remove('reports.employee.edit.invoices', index);
		}else {
			this.props.reportsEmployeeInvoiceDelete(employees.edit, employees.edit.invoices[index].id,modality, state, municipality)
		}
	}

	_submitForm(values){
		let {match, reports} = this.props;
		let { modality, state, municipality } = match.params;
		let {employees} = reports;

		if(employees.edit.id){
			this.props.reportsEmployeeInvoicesSave(values, modality, state, municipality);
		}else {
			this.props.reportsEmployeeAdd(values, modality, state, municipality);
		}
	}

	componentWillMount(){
		this.props.fetchConfigsShow();
	}
}

class ModalMessageExpenses extends Component {
	render(){
		let { data } = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content" style={{height: (!_.isEmpty(data) && _.isEmpty(data.invoices)) || (_.isEmpty(data)) ? 'auto':''}}>
					<div className="message">
						<div className="message-header">
							<p>Facturas</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<div className="columns">
								<div className="column is-6">
									<p>CURP</p>
									<p><strong>{data.curp}</strong></p>
								</div>
								<div className="column is-6">
									<p>Periodo de contratación</p>
									<p><strong>{data.period_start && data.period_end ? `${data.period_start} - ${data.period_end}`:(data.period_start ? data.period_start:'---')}</strong></p>
								</div>
							</div>
							<div className="columns">
								<div className="column is-6">
									<p>Sueldo</p>
									<p><strong>{formatMoney(data.wage ? data.wage:0)}</strong></p>
								</div>
							</div>

							{!_.isEmpty(data) && !_.isEmpty(data.invoices) ?
								<fieldset className="fieldset">
									<legend>Facturas</legend>
									<table className="inm-table">
										<thead>
										<tr>
											<th>Factura</th>
											<th>PDF</th>
											<th>XML</th>
											<th>SAT</th>
										</tr>
										</thead>
										<tbody>
										{_.map(data.invoices, (item,k) => {
											return(
												<tr key={k}>
													<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

													<td>
														<div className="control">
															<a href={item.pdf}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.xml}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.sat}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</fieldset>
								:''}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/elements/reports/employees.jsx